"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = exports.useStreamlit = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var streamlit_component_lib_1 = require("streamlit-component-lib");
/**
 * Returns `RenderData` received from Streamlit.
 */
var useStreamlit = function () {
    var _a = (0, react_1.useState)(), renderData = _a[0], setRenderData = _a[1];
    (0, react_1.useEffect)(function () {
        var onRenderEvent = function (event) {
            var renderEvent = event;
            setRenderData(renderEvent.detail);
        };
        // Set up event listeners, and signal to Streamlit that we're ready.
        // We won't render the component until we receive the first RENDER_EVENT.
        streamlit_component_lib_1.Streamlit.events.addEventListener(streamlit_component_lib_1.Streamlit.RENDER_EVENT, onRenderEvent);
        streamlit_component_lib_1.Streamlit.setComponentReady();
        var cleanup = function () {
            streamlit_component_lib_1.Streamlit.events.removeEventListener(streamlit_component_lib_1.Streamlit.RENDER_EVENT, onRenderEvent);
        };
        return cleanup;
    }, []);
    (0, react_1.useEffect)(function () {
        streamlit_component_lib_1.Streamlit.setFrameHeight();
    });
    return renderData;
};
exports.useStreamlit = useStreamlit;
/**
 * Shows errors thrown from child components.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: undefined };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { error: error };
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.error != null) {
            (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Component Error" }, void 0), (0, jsx_runtime_1.jsx)("span", { children: this.state.error.message }, void 0)] }, void 0);
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(react_1.default.PureComponent));
exports.ErrorBoundary = ErrorBoundary;
